import React from "react";
import { withRouter } from "react-router-dom";
import "../Styles/_FulfillmentInformation.css";
import { Warning, Confirmed } from "./_Icon";
import { orderUtils } from "../Helpers/OderUtils";

const AuthorizedInformation = ({ currentLanguage, order }) => {
    if (orderUtils.orderIsCancelled(order) || orderUtils.orderIsFullyRefunded(order)) {
        return false;
    }

    const subOrder = orderUtils.getMainSubOrder(order);

    if (!subOrder || !orderUtils.getCurrentSubOrderStatus(subOrder) || orderUtils.getCurrentSubOrderStatus(subOrder).status !== "AUTHORIZED") {
        return false;
    }

    return (
        <div>
            <div className="fulfillment-container allow-focus" tabIndex="0">
                <div className="fulfillment-container-label">
                    <Warning />
                    <p>{currentLanguage.ORDER_PAGE.AUTHORIZED_SECTION.AUTHORIZED_MESSAGE}</p>
                </div>
            </div>
        </div>
    );
};

export default withRouter(AuthorizedInformation);



// WEBPACK FOOTER //
// ./src/views/Order/components/_AuthorizedInformation.jsx